// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"_2E8gb","header":"_2PLnk","content":"uJtiP","title":"_1II4W"};